import { QueryKey } from 'constants/reactQuery';

export const contestsQueryKey = {
  contests: [QueryKey.Content] as const,
  contestsApplyCount: (contestId: number) => [...contestsQueryKey.contests, contestId, 'applyCount'] as const,
  contestsVoteCount: (contestId: number) => [...contestsQueryKey.contests, contestId, 'voteCount'] as const,
  contestsVoteContents: (contestId: number) => [...contestsQueryKey.contests, contestId, 'voteContents'] as const,
  contestsReplies: (contestId: number) => [...contestsQueryKey.contests, contestId, 'replies'] as const,
  contestsFancyShares: (contestId: number) => [...contestsQueryKey.contests, contestId, 'fancyShares'] as const,
  contestsVotePeriod: (contestId: number) => [...contestsQueryKey.contests, contestId, 'votePeriod'] as const,
  contestsVoteMessage: (contestId: number) => [...contestsQueryKey.contests, contestId, 'voteMessage'] as const,
  contestContents: (keywordIds: string[]) => [...contestsQueryKey.contests, keywordIds] as const,
  myContestContents: (contestId: number) => [...contestsQueryKey.contests, contestId, 'myContents'] as const,
  contentContest: (contestId: number, contentId: number) =>
    [...contestsQueryKey.contests, contestId, contentId] as const,
  contestStage: (contestId: number) => [...contestsQueryKey.contests, contestId, 'stage'] as const,
};
